import { render, staticRenderFns } from "./approval_list.vue?vue&type=template&id=9c54bab8&scoped=true"
import script from "./approval_list.vue?vue&type=script&lang=js"
export * from "./approval_list.vue?vue&type=script&lang=js"
import style0 from "./approval_list.vue?vue&type=style&index=0&id=9c54bab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c54bab8",
  null
  
)

export default component.exports